import { Route as PublicRoute } from 'react-router-dom';

import { PATH_NAME } from '../pathNames';
import { ComprehensiveReport } from '../lazyLoaded';

const ComprehensiveReportRoute = () => (
  <PublicRoute
    exact
    path={PATH_NAME.COMPREHENSIVE_REPORT}
    component={(props: JSX.IntrinsicAttributes) => (
      <ComprehensiveReport {...props} />
    )}
  />
);
export default ComprehensiveReportRoute;
